import React, { FC, ReactElement } from 'react'

import './DayHeader.scss'

interface HeaderProps {
    header: string
    className?: string
}

const DayHeader: FC<HeaderProps> = ({
    header,
    className = '',
}): ReactElement => (
    <div className={`day-header ${className}`}>
        {header}
    </div>
)

export default DayHeader
